module.exports = __webpack_public_path__ + "static/media/camiDeSonEixut.0aa473cf.png";